<template>
  <section class="faq" aria-labelledby="faq-title">
    <h2 v-if="titleKey" id="faq-title" class="faq-title">{{ $t(titleKey) }}</h2>
    <h2 v-else id="faq-title" class="faq-title">
      <span class="headline-bold">{{ $t('landing.faq.titleBold') }}</span>
      <span class="headline">{{ $t('landing.faq.titleRest') }}</span>
    </h2>
    <p v-if="!titleKey" class="faq-intro">{{ $t('landing.faq.intro') }}</p>

    <div class="faq-tabs" role="group" :aria-label="$t('landing.faq.audience')">
      <button
        v-for="a in audiences"
        :key="a"
        type="button"
        :class="{ active: audience === a }"
        :aria-pressed="audience === a ? 'true' : 'false'"
        @click="audience = a"
      >{{ $t('landing.faq.tabs.' + a) }}</button>
    </div>

    <div class="faq-list">
      <details v-for="n in counts[audience]" :key="audience + n" class="faq-item">
        <summary>
          <span>{{ $t(`landing.faq.${audience}.q${n}`) }}</span>
          <i class="fas fa-chevron-down faq-chevron" aria-hidden="true"></i>
        </summary>
        <p>{{ $t(`landing.faq.${audience}.a${n}`) }}</p>
      </details>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqSection',
  props: {
    initial: { type: String, default: 'citizens' }, // which audience opens first
    titleKey: { type: String, default: '' }, // replaces the citizen-voice title, e.g. on the cities page
  },
  data() {
    return {
      audience: this.initial,
      audiences: ['citizens', 'municipalities'],
      counts: { citizens: 5, municipalities: 5 },
    };
  },
};
</script>

<style scoped>
.faq { width: 100%; max-width: 100%; display: flex; flex-direction: column; gap: 16px; text-align: left; }
.faq-title { margin: 0; text-align: center; line-height: 1.2; }
.faq-intro { margin: 0; text-align: center; color: var(--color-secondary); }
.dark-mode .faq-intro { color: var(--color-text-light); }
.faq-tabs { display: flex; gap: 4px; padding: 4px; background: var(--color-subtle); border-radius: var(--radius-pill); }
.faq-tabs button { flex: 1; min-height: 44px; border: none; background: none; cursor: pointer; font: inherit; font-size: 15px; font-weight: 500; padding: 10px 12px; border-radius: var(--radius-pill); color: var(--color-secondary); }
.dark-mode .faq-tabs button { color: var(--color-text-light); }
.faq-tabs button.active { background: var(--color-primary); color: var(--color-on-primary); font-weight: 600; }
.faq-tabs button:focus-visible, summary:focus-visible { outline: 2px solid var(--color-primary-text); outline-offset: 2px; }
.faq-list { display: flex; flex-direction: column; gap: 8px; }
.faq-item { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-lg); }
.faq-item[open] { border-color: var(--color-primary); }
summary { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: var(--touch-min); padding: 12px 16px; cursor: pointer; font-weight: 600; list-style: none; border-radius: var(--radius-lg); }
summary::-webkit-details-marker { display: none; }
.faq-chevron { font-size: 12px; color: var(--color-primary-text); transition: transform .2s ease; flex-shrink: 0; }
.faq-item[open] .faq-chevron { transform: rotate(180deg); }
.faq-item p { margin: 0; padding: 0 16px 16px; line-height: 1.5; text-align: left; }
@media (prefers-reduced-motion: reduce) { .faq-chevron { transition: none; } }
</style>
